import { Component, OnInit, EventEmitter } from '@angular/core';
import { GlobalService } from '@common/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonService } from '@services/common.service';
import { fadeInUpOnEnterAnimation, bounceOutDownOnLeaveAnimation } from 'angular-animations';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
  animations: [
    fadeInUpOnEnterAnimation({ anchor: 'enter', duration: 1000, delay: 100, translate: '30px' }),
    bounceOutDownOnLeaveAnimation({ anchor: 'leave', duration: 500, delay: 200, translate: '40px' })
  
  ]
})
export class LoginComponent implements OnInit {
  pass_type=false;
  loginForm: FormGroup;
  showframe = false;
  navigateByUrl = false;
  btn_process = false;
  show_password = false;
  email_validate = false;
  returnUrl = "/";
  error: any = { };
  url = '';
  saavha_login = false;
  member_login = true;
  operation='';
  entity:any=[];
  application='member';
  constructor(private _commonService:CommonService, private route: ActivatedRoute, private fb: FormBuilder, private router: Router, public _global: GlobalService) {
    if (this._global.isAuthenticated()) {
      this.router.navigate(['/']);
    }
    this.operation='login';
    
    this.loginForm=this.fb.group(this._global.generateFormGroup(this.application, this.operation));

    this.route.queryParams.subscribe(params => {
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          if (key == "returnUrl") {
            this.returnUrl = value;
          }
          if (key == "navigateByUrl") {
            this.navigateByUrl = value;
          }
        }
      });
    });
    console.log("this.returnUrl", this.returnUrl, this.navigateByUrl)
  }

  ngOnInit() {
  }

  cancel() {
    if (this.navigateByUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      this.router.navigate([this.returnUrl]);
    }
  }
  public login() {
    this.error = {};
    this.btn_process = true;
    let r = this.loginForm.value;
    r = this._global.paramsRemoveNull(r);
    this._commonService.common(r,this.operation,this.application).subscribe(
      data => {
        if (data["status"] == 1) {
          localStorage.removeItem(this._global.SESSION_KEY);
          localStorage.setItem(this._global.SESSION_KEY, JSON.stringify(data["response"]));

          if (this.navigateByUrl) {
            this.router.navigateByUrl(this.returnUrl);
          } else {
            this.router.navigate([this.returnUrl]);
          }
        }else if (data["status"] == "-2") {  
          this.btn_process = false;
          this.error['error'] = this._global.getVal(data, 'message.error', '');
          this._global.showMessage({ severity: 'warning', message: this._global.getVal(data, 'message.error', '') });
        }
        else {
          this.btn_process = false;
          for (let key in data["errors"]) {
            this.error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("Validate Error", error);
      });
  }
  forgotPassword() {
    let params = {};
    let r = this.loginForm.value;
    r = this._global.paramsRemoveNull(r);
    params["email"] = r.email;
    this.router.navigate(['/forgot-password', params]);
  }
  signUp() {
    let r = this.loginForm.value;
    r = this._global.paramsRemoveNull(r);
    let params = {};
    params["email"] = r.email;
    this.router.navigate(['/register', params]);
  }
  gotoSaavha() {

    this.error = { "email": "", "password": "" };
    this.saavha_login = true;
    this.member_login = false;
  }
  public validate() {
    this.error = {  };
    this.btn_process = true;
    let r = this.loginForm.value;
    r = this._global.paramsRemoveNull(r);
    let p = {
      email: r.email
    };
    this._commonService.common(p,'duplicate',this.application).subscribe(
      data => {
        if (data["status"] == 1) {
          this.btn_process = false;
          this.email_validate = true;
          this.saavhaLogin();
        }
        else {
          let params = {};
          params["email"] = r.email;
          this.router.navigate(['/register', params]);
        }
      },
      error => {
        console.log("Validate Error", error);
      });
  }
  saavhaLogin() {
    this.showframe = true;
    this.saavha_login = false;
    let j = 0;
    this.url = "https://auth.saavha.com/login;sess_cookie=" + this._global.getToken() + ";token=" + this._global.getToken() + ";domain=" + this._global.DOMAIN_NAME + ";email=" + this.loginForm.value["email"];
    let THIS = this;
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    eventer(messageEvent, function (event) {
      if (event.origin !== THIS._global.ORIGIN)
        return;
      else {
        console.log('LoginComponent: gotoSaavha: received message : ', event.data);
        var sessionObject = JSON.parse(event.data);
        if (sessionObject != null) {
          var sessionKeyObj = sessionObject[THIS._global.SESSION_KEY];
          if (sessionKeyObj == undefined || sessionKeyObj == null) {
            console.log('LoginComponent: gotoSaavha: sessionKeyObj is null or undefined : ', sessionKeyObj);
            return;
          }
          else {
            console.log('LoginComponent: iframeLoad: sessionKeyObj found value = : ', sessionKeyObj);
            localStorage.setItem(THIS._global.SESSION_KEY, event.data);
            if (THIS.navigateByUrl) {
              this.router.navigateByUrl(THIS.returnUrl);
            } else {
              THIS.router.navigate([THIS.returnUrl]);
            }
          }
        }
        else
          return;
      }
    }, false);
  }

}

